import { Trans } from '@lingui/react'
import { func, string } from 'prop-types'

import OffCanvasNewItem from 'views/components/organisms/OffCanvasNew/OffCanvasNewItem'
import { offCanvasNewHeader } from 'views/utils/propTypes'

const OffCanvasNewList = props => {
  const { items, onItemSelect, children, dataQaId } = props
  return (
    <ul className="a-list-reset">
      {items.map(item => {
        const { id, label, icon } = item
        return (
          <li key={id}>
            <OffCanvasNewItem
              id={id}
              showItemArrow
              icon={icon}
              dataQaId={dataQaId}
              onClick={() => onItemSelect && onItemSelect(item)}
            >
              <Trans id={label} />
            </OffCanvasNewItem>
          </li>
        )
      })}
      {children}
    </ul>
  )
}

OffCanvasNewList.propTypes = {
  items: offCanvasNewHeader.isRequired,
  onItemSelect: func,
  children: func,
  dataQaId: string,
}

OffCanvasNewList.defaultProps = {}

export default OffCanvasNewList
